import Tooltip from '@mui/material/Tooltip';
import { ReactNode, useCallback } from 'react';

import PreviewCard from './previewCard';

interface ReportPreviewProps {
  children: ReactNode;
  referenceID: string;
  decryptText: (text: string) => Promise<string>;
}

const ReportPreview = ({
  children,
  referenceID,
  decryptText,
}: ReportPreviewProps) => {
  const processText = useCallback(
    (value: string) => {
      return decryptText(value);
    },
    [decryptText],
  );

  return (
    <Tooltip
      placement='right'
      title={
        <PreviewCard referenceID={referenceID} decryptText={processText} />
      }
      enterNextDelay={500}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: 'white',
            padding: '16px',
            minWidth: '460px',
            boxShadow: '0px 4px 12px 0px #00000047',
          },
        },
      }}
    >
      <div>{children}</div>
    </Tooltip>
  );
};

export default ReportPreview;
